import React from "react";
import { Text as BaseText, BoxProps } from "@chakra-ui/react";

export default function Text(props: BoxProps) {
  return <BaseText color="gray.700" {...props} />;
}
